module.exports = __webpack_public_path__ + "static/media/Fabian_D@3x.d2013e62.jpg";